/**
 * After a deploy the old hashed chunks are gone, so a tab opened before it
 * fails to load the next page it has not visited yet. Reloading fetches the
 * new index.html and its chunks. Guarded so a real outage cannot loop.
 */

const KEY = 'mf.chunk-reload-at'
const RETRY_AFTER_MS = 10_000

export function isChunkLoadError(error: unknown) {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS|ChunkLoadError/i.test(message)
}

/** Reloads the tab unless it already did in the last few seconds; returns whether it reloads. */
export function reloadForNewVersion() {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0)
    if (Date.now() - last < RETRY_AFTER_MS) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    /* storage unavailable: reload anyway */
  }
  window.location.reload()
  return true
}

/**
 * A reload the user asked for. It clears the loop guard first: the guard exists
 * to stop automatic retries spinning, not to refuse an explicit "Reload page".
 */
export function forceReload() {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* storage unavailable: reload anyway */
  }
  window.location.reload()
}
